import { render, staticRenderFns } from "./DocumentTypeDetailForm.vue?vue&type=template&id=8593fb3e&"
import script from "./DocumentTypeDetailForm.vue?vue&type=script&lang=js&"
export * from "./DocumentTypeDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTypeDetailForm.vue?vue&type=style&index=0&id=8593fb3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports